// eslint-disable-next-line
import React from "react";
import { Link } from "react-router-dom";
import { IoIosArrowBack } from "react-icons/io";
const ShowAllProducts = () => {
  return (
    <div className="container mx-auto">
      <div className="flex items-center justify-center gap-8 mt-5">
        <span className="h-px bg-gray-200 flex-1 block"></span>
        <Link
          to={"view-products"}
          className="btn btn--outline-primary h-10 grow-0 gap-1.5 group !px-2 !rounded-none"
        >
          <div className="flex items-center gap-1.5 px-3 py-1 bg-slate-200 rounded-md text-bold">
            <IoIosArrowBack style={{fontWeight:"bold"}} className="text-lg text-slate-400 hover:-translate-x-2 transition-transform duration-300" />
            <span style={{fontWeight:"bold"}} className="text-bold animate-pulse ">Show All</span>
          
          </div>
        </Link>
        <span className="h-px bg-gray-200 flex-1 block"></span>
      </div>
    </div>
  );
};

export default ShowAllProducts;
